import {
  Identifiable,
  List,
  list,
  planzone,
  Planzone,
  Project,
  Zone,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedProject, Linker } from "../linkers/types";

type Response = {
  _embedded: {
    projects: (LinkedProject & {
      activityRoot: Identifiable<List>;
      _links: {
        [key: string]: { href: string };
      };
    })[];
  };
};

function getTemplateZone(httpClient: HttpClient) {
  return (planzone: Identifiable<Planzone>) =>
    httpClient
      .sendHttpRequest<{
        _embedded: {
          zones: (Identifiable<Zone> & { savingTemplates: boolean })[];
        };
      }>({
        endpoint: `/zones/search/rsql?query=planzone.uuid==${planzone.uuid} and savingTemplates==true`,
        method: HttpMethods.GET,
      })
      .then(({ _embedded }) =>
        _embedded.zones.find(({ savingTemplates }) => savingTemplates),
      )
      .then((zone) => (zone ? zone : Promise.reject()));
}

function getProjectModels(httpClient: HttpClient, linker: Linker) {
  return (planzone: Identifiable<Planzone>) =>
    new Promise<Identifiable<Project>[]>((resolve, reject) =>
      getTemplateZone(httpClient)(planzone).then((zone) =>
        httpClient
          .sendHttpRequest<Response>({
            endpoint: `/projects/search/rsql?query=zone.uuid=='${zone.uuid}'&projection=details&size=9999`,
            method: HttpMethods.GET,
          })
          .then(({ _embedded: { projects } }) =>
            projects.map((project) => ({
              ...project,
              zone,
              isTemplate: project.isTemplate || project.template,
              rootList: { ...list, ...project.activityRoot },
              tags: project.tags
                ? (project.tags as any).map((name: string) => ({ name }))
                : [],
            })),
          )
          .then(resolve)
          .catch((e) => reject({ ...e, message: e.details || "" })),
      ),
    );
}

export { getProjectModels };
